<template>
  <div id="trunk">
    <lead :headOption="headOption"/>
    <main class="main">
      <router-view />
    </main>
    <foote />
  </div>
</template>

<script>
import lead from "@/components/common/head";
import foote from '@/components/common/footer';
export default {
  components: {
    lead, foote,
  },
  data() {
    return {
      // 顶部模块标题：
      headOption: {
        link: "/calendar",
        title: "日程协同"
      },
    }
  }
}
</script>
<style lang="scss">
.main {
  min-height: calc(100vh - 204px);
  padding: 25px 0 40px;
  background-color: #fff;
}
@import "./../../../assets/css/calendar.scss";
</style>